import { apiConfig } from "../config/awsConfig";

// Add Note
export async function addNote(content, date, sharedWith, token) {
  const response = await fetch(`${apiConfig.baseUrl}notes`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      content,
      date,
      sharedWith,
    }),
  });

  if (!response.ok) {
    // throw new Error("Failed to add note");
    const error = await response.json();
    throw {error}
  }

  return await response.json();
}

export const updateNote = async (note_id, content, date, sharedWith, token) => {
  const response =  await fetch(`${apiConfig.baseUrl}notes`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      note_id,
      content,
      date,
      sharedWith
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw {error}
    // throw {message: error.message,status:error.cod};
    // throw new Error("Failed to add note");
  }

  return await response.json();
}

// Fetch Notes
export async function fetchNotes(selectedDate, token) {
  const encodedDate = encodeURIComponent(selectedDate);
  const response = await fetch(`${apiConfig.baseUrl}notes?date=${encodedDate}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    // throw new Error("Failed to fetch notes");
    const error = await response.json();
    throw {error}
  }

  return await response.json();
}

// Add a comment to a note
export async function addComment(note_id, date, comment, token) {
  const response = await fetch(`${apiConfig.baseUrl}comments`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      note_id,
      date,
      comment
    }),
  });

  if (!response.ok) {
    // throw new Error("Failed to add note");
    const error = await response.json();
    throw {error}
  }

  return await response.json();
}

export const fetchComments = async (note_id, token) => {
  const encodedNote = encodeURIComponent(note_id);
  const response =  await fetch(`${apiConfig.baseUrl}comments?note=${encodedNote}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // Pass the user's token for authentication
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(`Failed to fetch comments: ${error.message}`);
  }

  return await response.json(); // Return the fetched comments as JSON
};


export const fetchSharedNotes = async (selectedDate, token) => {
  const encodedDate = encodeURIComponent(selectedDate);
  const response =  await fetch(`${apiConfig.baseUrl}shared_notes?date=${encodedDate}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // Pass the user's token for authentication
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(`Failed to fetch shared notes: ${error}`);
  }

  return await response.json(); // Return the fetched comments as JSON
};


// // Fetch comments for a note
// export async function fetchComments(note_id, token) {
//   const response = await fetch(`${apiConfig.baseUrl}comments?note_id=${note_id}`, {
//     method: "GET",
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });

//   if (!response.ok) {
//     throw new Error("Failed to fetch notes");
//   }

//   return await response.json();
// }